// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dimple-title-divider[data-v-5cc9f936]{display:flex;align-items:center;padding:.521vw .938vw}.dimple-title-divider .border[data-v-5cc9f936]{height:.729vw;width:.208vw;margin-right:.208vw}.dimple-title-divider .title[data-v-5cc9f936]{font-size:.729vw;color:#333;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
